export default __webpack_public_path__ + "static/media/back.08688d70.svg";